module.exports = __webpack_public_path__ + "img/dcsp-tip.7ba1a24f.png";